import { createStyles, makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() =>
  createStyles({
    close: {
      left: 'auto',
      position: 'absolute',
      right: '30px',
      top: '30px',
    },
    info: {
      position: 'absolute',
      top: '50%',
      left: '10%',
    },
    paper: {
      alignItems: 'center',
      backgroundColor: '#fff',
      border: '2px solid #000',
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      overflowY: 'scroll',
      paddingTop: '5%',
      position: 'absolute',
      width: '100%',
    },
    title: {
      fontFamily: 'Montserrat',
      fontSize: '1.2em',
      fontWeight: 'bold',
      margin: '0 0 2vh',
      textAlign: 'left',
      textTransform: 'uppercase',
    },
  })
);
